import { minutesToMilliseconds } from 'date-fns';
import { queryOptions } from '@tanstack/react-query';

import {
  getAudienceGroup,
  getAudienceGroupOptions,
  getAudienceGroups,
} from 'services/backend/audienceGroup';

export const audienceGroupQueries = {
  all: () => ['audienceGroups'],
  get: (opts: { audienceGroupId: number }) =>
    queryOptions({
      queryFn: () =>
        getAudienceGroup({ audienceGroupId: opts.audienceGroupId }),
      queryKey: [...audienceGroupQueries.all(), opts.audienceGroupId],
      staleTime: minutesToMilliseconds(30),
    }),
  list: () =>
    queryOptions({
      queryFn: () => getAudienceGroups(),
      queryKey: audienceGroupQueries.all(),
      staleTime: minutesToMilliseconds(30),
    }),
  options: (opts: { audienceGroupId: number }) =>
    queryOptions({
      queryFn: () =>
        getAudienceGroupOptions({ audienceGroupId: opts.audienceGroupId }),
      queryKey: [
        ...audienceGroupQueries.all(),
        opts.audienceGroupId,
        'options',
      ],
      staleTime: minutesToMilliseconds(30),
    }),
};
